module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trf-page"
  }, [_c('container', [_c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Add Trainer")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Create a trainer account, profile details and mobile app introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "trf-card"
  }, [_c('div', {
    staticClass: "trf-card-header"
  }, [_c('span', {
    staticClass: "trf-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22 10L12 5 2 10l10 5 10-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6 12v5c0 1.66 2.69 3 6 3s6-1.34 6-3v-5"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "trf-card-title"
  }, [_vm._v("Trainer Profile")]), _vm._v(" "), _c('p', {
    staticClass: "trf-card-subtitle"
  }, [_vm._v("Set up the login identity, public profile and trainer media")])])]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "trf-error"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 8v4M12 16h.01"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-form', {
    attrs: {
      "handle-submit": _vm.handleSubmit
    }
  }, [_c('section', {
    staticClass: "trf-section"
  }, [_c('div', {
    staticClass: "trf-section-heading"
  }, [_c('span', {
    staticClass: "trf-section-kicker"
  }, [_vm._v("Account Identity")]), _vm._v(" "), _c('p', {
    staticClass: "trf-section-copy"
  }, [_vm._v("These fields create the trainer login and display name.")])]), _vm._v(" "), _c('div', {
    staticClass: "trf-field-grid"
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "trf-field",
    attrs: {
      "name": "firstName",
      "data-vv-value-path": "input",
      "data-vv-name": "firstName",
      "message-error": _vm.errors && _vm.errors.first ? _vm.errors.first('firstName') : '',
      "has-error": _vm.errors && _vm.errors.has ? _vm.errors.has('firstName') : '',
      "block": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trainer.firstName),
      callback: function($$v) {
        _vm.$set(_vm.trainer, "firstName", $$v)
      },
      expression: "trainer.firstName"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n                First name "), _c('span', {
    staticClass: "trf-required"
  }, [_vm._v("*")])])], 2), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "trf-field",
    attrs: {
      "name": "lastName",
      "data-vv-value-path": "input",
      "data-vv-name": "lastName",
      "message-error": _vm.errors && _vm.errors.first ? _vm.errors.first('lastName') : '',
      "has-error": _vm.errors && _vm.errors.has ? _vm.errors.has('lastName') : '',
      "block": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trainer.lastName),
      callback: function($$v) {
        _vm.$set(_vm.trainer, "lastName", $$v)
      },
      expression: "trainer.lastName"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n                Last name "), _c('span', {
    staticClass: "trf-required"
  }, [_vm._v("*")])])], 2), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "trf-field",
    attrs: {
      "name": "user.email",
      "data-vv-value-path": "input",
      "data-vv-name": "user.email",
      "message-error": _vm.errors && _vm.errors.first ? _vm.errors.first('user.email') : '',
      "has-error": _vm.errors && _vm.errors.has ? _vm.errors.has('user.email') : '',
      "block": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trainer.user.email),
      callback: function($$v) {
        _vm.$set(_vm.trainer.user, "email", $$v)
      },
      expression: "trainer.user.email"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n                E-mail "), _c('span', {
    staticClass: "trf-required"
  }, [_vm._v("*")])])], 2), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "trf-field",
    attrs: {
      "name": "nickname",
      "data-vv-value-path": "input",
      "data-vv-name": "nickname",
      "message-error": _vm.errors && _vm.errors.first ? _vm.errors.first('nickname') : '',
      "has-error": _vm.errors && _vm.errors.has ? _vm.errors.has('nickname') : '',
      "block": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trainer.nickname),
      callback: function($$v) {
        _vm.$set(_vm.trainer, "nickname", $$v)
      },
      expression: "trainer.nickname"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n                Nickname (username) "), _c('span', {
    staticClass: "trf-required"
  }, [_vm._v("*")])])], 2), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "trf-field",
    attrs: {
      "name": "user.password",
      "type": "password",
      "data-vv-value-path": "input",
      "data-vv-name": "user.password",
      "message-error": _vm.errors && _vm.errors.first ? _vm.errors.first('user.password') : '',
      "has-error": _vm.errors && _vm.errors.has ? _vm.errors.has('user.password') : '',
      "block": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trainer.user.password),
      callback: function($$v) {
        _vm.$set(_vm.trainer.user, "password", $$v)
      },
      expression: "trainer.user.password"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n                Password "), _c('span', {
    staticClass: "trf-required"
  }, [_vm._v("*")])])], 2)], 1)]), _vm._v(" "), _c('section', {
    staticClass: "trf-section"
  }, [_c('div', {
    staticClass: "trf-section-heading"
  }, [_c('span', {
    staticClass: "trf-section-kicker"
  }, [_vm._v("Profile Details")]), _vm._v(" "), _c('p', {
    staticClass: "trf-section-copy"
  }, [_vm._v("Add optional context shown in trainer-facing experiences.")])]), _vm._v(" "), _c('div', {
    staticClass: "trf-field-stack"
  }, [_c('v-text-field', {
    staticClass: "trf-field trf-field--textarea",
    attrs: {
      "name": "aboutMe",
      "block": true,
      "multiple-lines": true
    },
    model: {
      value: (_vm.trainer.aboutMe),
      callback: function($$v) {
        _vm.$set(_vm.trainer, "aboutMe", $$v)
      },
      expression: "trainer.aboutMe"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n                About me\n              ")])], 2), _vm._v(" "), _c('v-text-field', {
    staticClass: "trf-field",
    attrs: {
      "name": "introductionUrl",
      "data-vv-value-path": "input",
      "data-vv-name": "introductionUrl",
      "block": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trainer.introductionUrl),
      callback: function($$v) {
        _vm.$set(_vm.trainer, "introductionUrl", $$v)
      },
      expression: "trainer.introductionUrl"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n                Trainer introduction web\n              ")])], 2)], 1)]), _vm._v(" "), _c('section', {
    staticClass: "trf-section"
  }, [_c('div', {
    staticClass: "trf-section-heading"
  }, [_c('span', {
    staticClass: "trf-section-kicker"
  }, [_vm._v("Media")]), _vm._v(" "), _c('p', {
    staticClass: "trf-section-copy"
  }, [_vm._v("Upload the trainer photo used across console and mobile surfaces.")])]), _vm._v(" "), _c('div', {
    staticClass: "trf-upload-row"
  }, [_c('div', {
    staticClass: "trf-upload-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "17 8 12 3 7 8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "3",
      "x2": "12",
      "y2": "15"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "trf-upload-body"
  }, [_c('v-upload-field', {
    staticClass: "trf-upload-field",
    attrs: {
      "url": "trainers/upload-image",
      "block": true
    },
    on: {
      "fileUrl": _vm.setPhotoUrl
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n                  Photo upload\n                ")])], 2), _vm._v(" "), _c('p', {
    staticClass: "trf-upload-note"
  }, [_vm._v("Use a clear trainer image. Uploaded files continue through the existing trainer image endpoint.")]), _vm._v(" "), (_vm.trainer.photoUrl) ? _c('div', {
    staticClass: "trf-upload-success"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })]), _vm._v("\n                Photo uploaded\n              ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "trf-actions"
  }, [_c('v-button', {
    staticClass: "trf-save-btn",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "17 21 17 13 7 13 7 21"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "7 3 7 8 15 8"
    }
  })]), _vm._v("\n            " + _vm._s(_vm.loading ? 'Saving...' : 'Save Trainer') + "\n          ")])], 1)])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1989691a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/TrainerManager/Add.vue
// module id = 1669
// module chunks = 2